<!--
    os botões da coluna de ações a serem exibidos são escolhidos
    no componente em que a tabela será exibida
-->
<div class="actions-buttons">
    <a *ngIf="exibirAtivacao && !isAssessor && objeto?.statusCadastro != statusUsuario.ATIVO" class="btn table-btn"
      title="Ativar" (click)="executarAcaoExtra(acoesExtra.Ativar, objeto)">
      <icons-primecap name="check"></icons-primecap>
    </a>

    <a *ngIf="exibirDesativacao && !isAssessor && objeto?.statusCadastro == statusUsuario.ATIVO" class="btn table-btn"
      title="Desativar" (click)="executarAcaoExtra(acoesExtra.Desativar, objeto)">
      <icons-primecap name="uncheck"></icons-primecap>
    </a>

    <a *ngIf="exibirAtivacao && isAssessor && objeto?.usuarioStatusCadastro != statusUsuario.ATIVO" class="btn table-btn"
      title="Ativar" (click)="executarAcaoExtra(acoesExtra.Ativar, objeto)">
      <icons-primecap name="check"></icons-primecap>
    </a>

    <a *ngIf="exibirDesativacao && isAssessor && objeto?.usuarioStatusCadastro == statusUsuario.ATIVO" class="btn table-btn"
      title="Desativar" (click)="executarAcaoExtra(acoesExtra.Desativar, objeto)">
      <icons-primecap name="uncheck"></icons-primecap>
    </a>

    <a *ngIf="exibirDashboard" class="btn table-btn" title="Dashboard"
        (click)="executarAcaoExtra(acoesExtra.Dashboard, objeto)">
        <icons-primecap name="dashboard"></icons-primecap>
    </a>

    <a *ngIf="exibirAbrirPagina" class="btn table-btn" title="{{tituloAbrirPagina}}"
      (click)="executarAcaoExtra(acoesExtra.Abrir, objeto)">
      <icons-primecap [name]="iconeAbrirPagina"></icons-primecap>
    </a>

    <a *ngIf="exibirEnviarBoleto" class="btn table-btn" title="Enviar Cobrança"
        (click)="executarAcaoInvestimento(acoesInvestimento.Enviar_Boleto, objeto)">
        <icons-primecap name="barcode"></icons-primecap>
    </a>

    <a *ngIf="exibirAssinarInvestimento" class="btn table-btn" title="Assinar"
        (click)="executarAcaoInvestimento(acoesInvestimento.Assinar, objeto)">
        <icons-primecap name="like"></icons-primecap>
    </a>

    <a *ngIf="exibirConfirmarPagamento" class="btn table-btn" title="Confirmar"
        (click)="executarAcaoInvestimento(acoesInvestimento.Confirmar, objeto)">
        <icons-primecap name="like"></icons-primecap>
    </a>

    <a *ngIf="exibirRecusarInvestimento" class="btn table-btn" title="Recusar"
        (click)="executarAcaoInvestimento(acoesInvestimento.Recusar, objeto)">
        <icons-primecap name="dislike"></icons-primecap>
    </a>

    <a *ngIf="exibirAnalisarInvestimento" class="btn table-btn" title="Pôr em análise"
        (click)="executarAcaoInvestimento(acoesInvestimento.Por_Em_Analise, objeto)">
        <icons-primecap name="relogio-areia"></icons-primecap>
    </a>

    <!-- botão de editar rodada de investimento somente é exibido se o status for STAND_BY -->
    <a *ngIf="isRodadaInvestimento && objeto?.status == 'STAND_BY'" class="btn table-btn" title="Editar"
        (click)="executarAcaoCrud(acoesCrud.Atualizar, objeto)">
        <icons-primecap name="caneta"></icons-primecap>
    </a>

    <!-- botão de excluir rodada de investimento somente é exibido se o status for STAND_BY -->
    <a *ngIf="isRodadaInvestimento && objeto?.status == 'STAND_BY'" class="btn table-btn" title="Remover"
        (click)="executarAcaoCrud(acoesCrud.Deletar, objeto)">
        <icons-primecap name="lixeira"></icons-primecap>
    </a>

    <a *ngIf="exibirEdicao && !isRodadaInvestimento" class="btn table-btn" title="Editar"
        (click)="executarAcaoCrud(acoesCrud.Atualizar, objeto)">
        <icons-primecap name="caneta"></icons-primecap>
    </a>

    <a *ngIf="exibirDelecao && !isRodadaInvestimento" class="btn table-btn" title="Remover"
        (click)="executarAcaoCrud(acoesCrud.Deletar, objeto)">
        <icons-primecap name="lixeira"></icons-primecap>
    </a>
</div>
